import { render, staticRenderFns } from "./new_post_config.vue?vue&type=template&id=cf4f5f34&"
import script from "./new_post_config.vue?vue&type=script&lang=js&"
export * from "./new_post_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports